goog.provide('el8.ptdata.model.prenatalFlowsheetVisitMeasurement');

goog.require('el8.model.base');
goog.require('el8.ptdata.fetchById');

(function() {

    var _class = function(spec) {
        spec = spec || {};
        this.populate(spec);
    };

    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addIntProperty('flowsheetId', true);
    _class.addDate('date', true);
    _class.addStringProperty('weeksGest', true);
    _class.addStringProperty('fundlHt', true);
    _class.addStringProperty('pres', true);
    _class.addStringProperty('fhr', true);
    _class.addStringProperty('fetalMvmt', true);
    _class.addStringProperty('pretermSymp', true);
    _class.addStringProperty('crvxExamDil', true);
    _class.addStringProperty('crvxExamDff', true);
    _class.addStringProperty('crvxExamSta', true);
    _class.addStringProperty('bpS', true);
    _class.addStringProperty('bpD', true);
    _class.addStringProperty('weight', true);
    _class.addStringProperty('urineAlb', true);
    _class.addStringProperty('urineGlu', true);
    _class.addStringProperty('edema', true);
    _class.addStringProperty('nextAppt', true);
    _class.addStringProperty('comments', true);
    _class.addStringProperty('signUserName', true);

    _class.addBoolean('draft', true, false);

    _class.prototype.getFlowsheet = function() {
        return el8.ptdata.fetchById(this.getFlowsheetId());
    };

    _class.prototype.deleteVisitMeasurements = function() {
        var flowsheet = this.getFlowsheet();
        var visitMeasurements = [];

        for (var i = 0; i < flowsheet.getVisitMeasurements().length; i ++) {
            if (flowsheet.getVisitMeasurements()[i].getId() !== this.getId()) {
                visitMeasurements.push(flowsheet.getVisitMeasurements()[i]);
            }
        }

        el8.ptdata.prenatalFlowsheetVisitMeasurements.deleteItem(this);
        flowsheet.setVisitMeasurements(visitMeasurements);
    };

    el8.ptdata.model.prenatalFlowsheetVisitMeasurement = function(spec) {
        return new _class(spec);
    };

})();
